var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google - Original",
    clipPath: "url(#clip0_15617_2769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8841 6.63822C11.8841 6.23035 11.851 5.82029 11.7805 5.41904H6.12109V7.72953H9.36196C9.22748 8.4747 8.79536 9.1339 8.16262 9.55279V11.052H10.0961C11.2315 10.0069 11.8841 8.46368 11.8841 6.63822Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.11956 12.5004C7.73779 12.5004 9.10248 11.9691 10.0968 11.0519L8.16329 9.55277C7.62535 9.91875 6.93088 10.126 6.12177 10.126C4.55645 10.126 3.22924 9.06995 2.75304 7.65015H0.757812V9.19562C1.77637 11.2217 3.85096 12.5004 6.11956 12.5004Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.75236 7.65014C2.50103 6.90496 2.50103 6.09805 2.75236 5.35287V3.8074H0.759345C-0.0916566 5.50279 -0.0916566 7.50022 0.759345 9.19561L2.75236 7.65014Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.11956 2.87483C6.97497 2.8616 7.80172 3.18348 8.42123 3.77433L10.1343 2.06131C9.04956 1.04275 7.60992 0.482767 6.11956 0.500404C3.85096 0.500404 1.77637 1.77911 0.757812 3.8074L2.75083 5.35287C3.22483 3.93087 4.55425 2.87483 6.11956 2.87483Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15617_2769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.c24d8622ec631f0f4dba0388e833b534.svg";
export { ForwardRef as ReactComponent };